const __WEBPACK_NAMESPACE_OBJECT__ = createAuth0Client;